type EmojiProps = {
  emoji: string
  ariaLabel: string
}

const Emoji = ({ emoji, ariaLabel }: EmojiProps) => (
  <span role="img" aria-label={ariaLabel}>
    {emoji}
  </span>
)

export default Emoji
